__turbopack_context__.v({
  "background": "SiteBackground-module__VODPTG__background",
  "interactive": "SiteBackground-module__VODPTG__interactive",
  "preview": "SiteBackground-module__VODPTG__preview",
  "quiet": "SiteBackground-module__VODPTG__quiet",
});
